export class NumberUtils {

    /**
     * Rounds a floating-point number
     * @param value The floating-point number
     * @returns The fixed value
     */
    static round(value: number): number {
        return Math.round((value + Number.EPSILON) * 100) / 100;
      }

}
